<div class="login-container">
  <div class="login-card">
    <div class="login-header">
      <div class="lang-switcher-wrapper">
        <button (click)="toggleTheme()" class="theme-btn" [attr.aria-label]="'Toggle Theme'">
          <mat-icon>{{ isDarkMode ? 'light_mode' : 'dark_mode' }}</mat-icon>
        </button>
        <button (click)="toggleLanguage()" class="lang-btn">
          <img
            [src]="
              translate.currentLang === 'en'
                ? 'https://flagcdn.com/24x18/br.png'
                : 'https://flagcdn.com/24x18/us.png'
            "
            [alt]="translate.currentLang === 'en' ? 'English' : 'Português'"
          />
          <span>{{ translate.currentLang === 'en' ? 'PT' : 'EN' }}</span>
        </button>
      </div>
      <img [src]="currentLogo" [alt]="currentTenantName" class="logo" />
      <div class="d-flex flex-column">
        <h3 class="mt-3">{{ 'AUTH.LOGIN.TITLE' | translate }}</h3>
        <span>{{ 'AUTH.LOGIN.SUBTITLE' | translate }}</span>
      </div>
    </div>

    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="login-form">
      <z-input
        [label]="'AUTH.LOGIN.EMAIL_LABEL' | translate"
        [formControlRef]="$any(loginForm.get('email'))"
        [required]="true"
        [email]="true"
        [icon]="'email'"
      >
      </z-input>

      <z-input-password
        [label]="'AUTH.LOGIN.PASSWORD_LABEL' | translate"
        [formControlRef]="$any(loginForm.get('password'))"
        [required]="true"
      >
      </z-input-password>

      <div class="form-actions">
        <a routerLink="/auth/forgot-password" class="forgot-password">{{
          'AUTH.LOGIN.FORGOT_PASSWORD' | translate
        }}</a>
      </div>

      <div class="submit-button">
        <z-button
          [disabled]="loginForm.invalid || (loading | async) === true"
          [matType]="'flat'"
          [buttonType]="'submit'"
        >
          @if (loading | async) {
            <mat-spinner diameter="24" class="custom-spinner"></mat-spinner>
          } @else {
            <span>{{ 'AUTH.LOGIN.SUBMIT' | translate }}</span>
          }
        </z-button>
      </div>
    </form>

    <div class="login-footer">
      <span class="me-1">{{ 'AUTH.LOGIN.NO_ACCOUNT' | translate }}</span>
      <a routerLink="/cadastro-investidor">{{ 'AUTH.LOGIN.REGISTER' | translate }}</a>
    </div>
  </div>
</div>
